if (process.env.NODE_ENV === 'production') {
  module.exports = require('./react-dye.production.js');
} else {
  module.exports = require('./react-dye.development.js');
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@team-griffin/react-dye/dist/es/react-dye.js
// module id = 1424
// module chunks = 0